/**
 * Strips a trailing slash from `pathname` when it is not the root `/`.
 * Unlike `normalizePathForRedirectComparison`, this does NOT lowercase.
 * Use for route matching where Contentful slug comparisons are case-sensitive.
 */
export function stripTrailingSlash(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname;
}

/**
 * True for Nuxt file-based shop routes (`/{locale}/shop/...`).
 * Used for store-config loading and skipping Contentful redirects (Magento owns those).
 */
export function isMagentoShopPath(pathname: string): boolean {
  return /\/shop(\/|$)/.test(stripTrailingSlash(pathname));
}
